import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import type {HideableValue} from '@wix/devzai-utils-common';
import {hideableValueCreateHidden} from '@wix/devzai-utils-common';
import type {RichTextContent} from '@wix/devzai-utils-common';
import {
    BymoPagePropsContentSettingSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata,
    DoppeBusinessEntity,
} from '../../client-server-common';
import type {DoppeActionCtaButtonsSettings} from '../../client-server-common/types/doppe-action-cta-buttons-settings';
import {
    doppeActionCtaButtonsSettingsDefaultValuesMigration
} from '../../client-server-common/types/doppe-action-cta-buttons-settings';
import type {
    DoppeActionContentSectionsSettings
} from '../../client-server-common/types/doppe-action-content-sections-settings';
import {
    doppeActionContentSectionSettingsDefaultValuesMigration
} from '../../client-server-common/types/doppe-action-content-sections-settings';

export namespace DoppeActionTypeExternalForm {

    export interface ActionSettings extends DoppeActionCtaButtonsSettings, DoppeActionContentSectionsSettings {
        /** The Wix Form ID from the creator's metasite. */
        formId: string | null;

        title: HideableValue<string>;
        description: HideableValue<RichTextContent>;
    }
}

export const doppeActionTypeExternalFormMetadata = doppeActionTypeDefineMetadata<DoppeActionTypeExternalForm.ActionSettings>({
    id: 'co.hopp.action/wix-form',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction<DoppeActionTypeExternalForm.ActionSettings>({
        formId: null,
        title: hideableValueCreateHidden(''),
        description: hideableValueCreateHidden(''),
        ...doppeActionContentSectionSettingsDefaultValuesMigration({}),
        ...doppeActionCtaButtonsSettingsDefaultValuesMigration({}, false),
    }),
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            title: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityTitle),
            description: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.RichText, BymoPagePropsContentSettingSemanticMeaning.EntityDescription),
        },
        supportsActionCtaButtons: {
            customCtaButtonTypes: {}
        },
        supportsContentSections: {
            customContentSectionsTypes: {}
        },
        hideableContentSettingsNames: {
            description: true,
            title: true
        }
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: true,
    isFormAction: true,
    skipReportingOnGoalAchievedOnActionButtonClick: true,
    canRenderInPage: true,
    hasDisplaySettings: true,
    notSupportsSearch: true,
    lockIsNotSupported: true,
    resolveUsedBusinessEntities: actionSettings => {
        if (actionSettings.formId !== null) {
            return [{
                businessEntity: DoppeBusinessEntity.HoppForm,
                id: actionSettings.formId
            }];
        }
        return [];
    },
    resolveUsedMedia: _actionSettings => {
        return [];
    },
});
